export const formatNumber = (phoneNumber: string) : string => {
  let number = phoneNumber.replace(/\s/g,'')
  return number;
}